export const SET_EMAIL = 'signIn.setEmail'
export const SET_PASSWORD = 'signIn.setPassword'
export const SET_IS_VALID_EMAIL = 'signIn.setIsEmailValid'
export const SET_IS_VALID_PASSWORD = 'signIn.setIsValidPassword'
export const SET_IS_SUBMITTING = 'signIn.setIsSubmitting'
export const SET_ERROR = 'signIn.setError'
export const SET_IS_REQUEST_RESET_PASSWORD_DIALOG_OPEN = 'signIn.setIsRequestResetPasswordDialogOpen'
export const SET_IS_SENDING_RESET_PASSWORD_REQUEST = 'signIn.setIsSendingResetPasswordRequest'
export const SET_REQUEST_RESET_PASSWORD_EMAIL = 'signIn.setRequestResetPasswordEmail'
export const SET_IS_REQUEST_RESET_PASSWORD_EMAIL_VALID = 'signIn.setIsRequestResetPasswordEmailValid'
export const RESET = 'signIn.reset'

export function setEmail(email: string) {
  return {
    type: SET_EMAIL,
    payload: email
  } as const
}

export function setPassword(password: string) {
  return {
    type: SET_PASSWORD,
    payload: password
  } as const
}

export function setIsValidEmail(isValid: boolean) {
  return {
    type: SET_IS_VALID_EMAIL,
    payload: isValid
  } as const
}

export function setIsValidPassword(isValid: boolean) {
  return {
    type: SET_IS_VALID_PASSWORD,
    payload: isValid
  } as const
}

export function setIsSubmitting(isSubmitting: boolean) {
  return {
    type: SET_IS_SUBMITTING,
    payload: isSubmitting
  } as const
}

export function setError(error: string) {
  return {
    type: SET_ERROR,
    payload: error
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export function setIsRequestResetPasswordDialogOpen(isOpen: boolean) {
  return {
    type: SET_IS_REQUEST_RESET_PASSWORD_DIALOG_OPEN,
    payload: isOpen
  } as const
}

export function setIsSendingResetPasswordRequest(isSending: boolean) {
  return {
    type: SET_IS_SENDING_RESET_PASSWORD_REQUEST,
    payload: isSending
  } as const
}

export function setRequestResetPasswordEmail(email: string) {
  return {
    type: SET_REQUEST_RESET_PASSWORD_EMAIL,
    payload: email
  } as const
}

export function setIsRequestResetPasswordEmailValid(isValid: boolean) {
  return {
    type: SET_IS_REQUEST_RESET_PASSWORD_EMAIL_VALID,
    payload: isValid
  } as const
}

export type SignInAction = ReturnType<
  | typeof setEmail
  | typeof setPassword
  | typeof setIsValidEmail
  | typeof setIsValidPassword
  | typeof setIsSubmitting
  | typeof setError
  | typeof reset
  | typeof setIsRequestResetPasswordDialogOpen
  | typeof setIsSendingResetPasswordRequest
  | typeof setRequestResetPasswordEmail
  | typeof setIsRequestResetPasswordEmailValid
>
